const navbarI18n = {
  "fr": {
    "links": {
      "tarifs": "Vendre maintenant !",
      "secureSend": "Comment emballer ?",
      "criteria": "Critères de rachat"
    },
    "account": "Mes envois",
    "cart": "Panier"
  },
  "en": {
    "links": {
      "tarifs": "Sell now!",
      "secureSend": "How to pack?",
      "criteria": "Buyback criteria"
    },
    "account": "My shipments",
    "cart": "Cart"
  },
  "pl": {
    "links": {
      "tarifs": "Sprzedaj teraz!",
      "secureSend": "Jak zapakować?",
      "criteria": "Kryteria odkupu"
    },
    "account": "Moje przesyłki",
    "cart": "Koszyk"
  },
  "es": {
    "links": {
      "tarifs": "¡Vender ahora!",
      "secureSend": "¿Cómo embalar?",
      "criteria": "Criterios de recompra"
    },
    "account": "Mis envíos",
    "cart": "Carrito"
  },
  "it": {
    "links": {
      "tarifs": "Vendi subito!",
      "secureSend": "Come preparare?",
      "criteria": "Criteri di acquisto"
    },
    "account": "Le mie spedizioni",
    "cart": "Carrello"
  },
  "de": {
    "links": {
      "tarifs": "Jetzt verkaufen!",
      "secureSend": "Wie zu packen?",
      "criteria": "Rückkaufkriterien"
    },
    "account": "Meine Sendungen",
    "cart": "Warenkorb"
  },
  "pt": {
    "links": {
      "tarifs": "Vende agora!",
      "secureSend": "Como embalar?",
      "criteria": "Critérios de recompra"
    },
    "account": "Os meus envios",
    "cart": "Carrinho"
  },
  "cs": {
    "links": {
      "tarifs": "Prodat nyní!",
      "secureSend": "Jak zabalit zásilku?",
      "criteria": "Výkupní kritéria"
    },
    "account": "Moje zásilky",
    "cart": "Košík"
  },
  "nl": {
    "links": {
      "tarifs": "Verkoop nu!",
      "secureSend": "Hoe verpakken?",
      "criteria": "Inkoopcriteria"
    },
    "account": "Mijn zendingen",
    "cart": "Winkelwagen"
  }
};

export default navbarI18n;
